"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bignumber_js_1 = require("bignumber.js");
const errors_1 = require("@ledgerhq/errors");
const logic_1 = require("./logic");
const typhonjs_1 = require("@stricahq/typhonjs");
const errors_2 = require("./errors");
const errors_3 = require("../../errors");
const networks_1 = require("./networks");
const buildSubAccounts_1 = require("./buildSubAccounts");
const js_estimateMaxSpendable_1 = __importDefault(require("./js-estimateMaxSpendable"));
const js_buildTransaction_1 = require("./js-buildTransaction");
const getTransactionStatus = (a, t) => __awaiter(void 0, void 0, void 0, function* () {
    const errors = {};
    const warnings = {};
    const useAllAmount = !!t.useAllAmount;
    const cardanoResources = a.cardanoResources;
    const networkParams = (0, networks_1.getNetworkParameters)(a.currency.id);
    if (a.pendingOperations.length > 0) {
        throw new errors_3.AccountAwaitingSendPendingOperations();
    }
    const estimatedFees = t.fees || new bignumber_js_1.BigNumber(0);
    let amount = t.amount;
    let totalSpent = estimatedFees;
    const tokenAccount = t.subAccountId && a.subAccounts
        ? a.subAccounts.find(a => {
            return a.id === t.subAccountId;
        })
        : undefined;
    let tokensToSend = [];
    if (t.subAccountId) {
        // Token transaction
        if (!tokenAccount || tokenAccount.type !== "TokenAccount") {
            throw new Error("TokenAccount not found");
        }
        const { assetId } = (0, buildSubAccounts_1.decodeTokenCurrencyId)(tokenAccount.token.id);
        const { policyId, assetName } = (0, buildSubAccounts_1.decodeTokenAssetId)(assetId);
        amount = t.useAllAmount ? tokenAccount.balance : t.amount;
        totalSpent = amount;
        tokensToSend = [
            {
                policyId,
                assetName,
                amount,
            },
        ];
    }
    else {
        // ADA transaction
        amount = t.useAllAmount ? yield (0, js_estimateMaxSpendable_1.default)({ account: a, transaction: t }) : amount;
        totalSpent = amount.plus(estimatedFees);
    }
    const minTransactionAmount = typhonjs_1.utils.calculateMinUtxoAmount(tokensToSend, new bignumber_js_1.BigNumber(cardanoResources.protocolParams.lovelacePerUtxoWord), false);
    if (!t.fees) {
        errors.fees = new errors_1.FeeNotLoaded();
    }
    if (!t.recipient) {
        errors.recipient = new errors_1.RecipientRequired();
    }
    else if (!(0, logic_1.isValidAddress)(t.recipient, networkParams.networkId)) {
        errors.recipient = new errors_1.InvalidAddress();
    }
    if (!amount.gt(0)) {
        errors.amount = useAllAmount ? new errors_2.CardanoNotEnoughFunds() : new errors_1.AmountRequired();
    }
    else if (!t.subAccountId && amount.lt(minTransactionAmount)) {
        errors.amount = new errors_2.CardanoMinAmountError("", {
            amount: minTransactionAmount.div(1e6).toString(),
        });
    }
    else if (tokenAccount ? totalSpent.gt(tokenAccount.balance) : totalSpent.gt(a.balance)) {
        errors.amount = new errors_1.NotEnoughBalance();
    }
    else {
        try {
            yield (0, js_buildTransaction_1.buildTransaction)(a, t);
        }
        catch (e) {
            if (e.message.toLowerCase() === "not enough ada" ||
                e.message.toLowerCase() === "not enough tokens") {
                errors.amount = new errors_2.CardanoNotEnoughFunds();
            }
            throw e;
        }
    }
    return Promise.resolve({
        errors,
        warnings,
        estimatedFees,
        amount,
        totalSpent,
    });
});
exports.default = getTransactionStatus;
//# sourceMappingURL=js-getTransactionStatus.js.map